import React, { PureComponent } from "react";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Container,
  Row,
  Col
} from "reactstrap";
import axios from "axios";
import { StrIsEmailValidation, isNullOrEmpty } from "../helpers/utils";
import ReCAPTCHA from "react-google-recaptcha";
import HeaderImage from "../HeaderImage";

import appClasses from "../App.module.scss";
import classes from "./ContactUs.module.scss";

import _ from "lodash";

class ContactUs extends PureComponent {
  //pureComponent for validation , less re-renders,
  //Doesn’t rerender if props/state hasn’t changed.
  // and has shallow compare implementation for shouldComponentUpdate() similar to PureRenderMixin

  constructor(props) {
    super(props);
    this.state = {
      captchaSuccess: false,
      captchaClass: "",
      fullName: "",
      email: "",
      companyName: "",
      content: "",
      subscrib: false,
      fullNameValidated: true,
      emailValidated: true,
      contentValidated: true,
      userMessage: "",
      errorMessage: false,
      viewName: {
        firstLine: "צור",
        secondLine: "קשר"
      }
    };
    this.recaptchaRef = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.cheackBoxHandleChange = this.cheackBoxHandleChange.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
    //
    this.validateFullName = this.validateFullName.bind(this);
    this.validateContent = this.validateContent.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.captchaChange = this.captchaChange.bind(this);
  }

  captchaChange() {
    this.setState({ captchaSuccess: true });
    this.setState({ captchaClass: "" });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  cheackBoxHandleChange(event) {
    this.setState({ subscrib: event.target.checked });
  }

  componentDidUpdate(prevProps, prevState) {
    //this.validateEmail(this.state);
  }

  sendEmail() {
    let that = this;
    this.allowEmptyValidation = false;
    this.validateAllFields(false);
    if (!this.state.captchaSuccess) {
      this.setState({ captchaClass: appClasses["validation-error"] });
    }
    if (
      this.state.fullNameValidated &&
      this.state.emailValidated &&
      this.state.contentValidated &&
      this.state.captchaSuccess
    ) {
      console.log("sending email...");
      axios
        .post("api/files/contactUs", {
          fullName: this.state.fullName,
          subscrib: this.state.subscrib,
          email: this.state.email,
          companyName: this.state.companyName,
          content: this.state.content
        })
        .then(function(response) {
          if (response.status == "200") {
            that.allowEmptyValidation = true;
            that.setState({
              captchaSuccess: false,
              captchaClass: "",
              userMessage: "פנייתך נשלחה בהצלחה ותטופל בהקדם.",
              errorMessage: false,
              fullName: "",
              email: "",
              companyName: "",
              content: "",
              subscrib: false,
              fullNameValidated: true,
              emailValidated: true,
              contentValidated: true
            });
            that.recaptchaRef.current.reset();
          } else {
            that.setState({
              userMessage: "שליחת פנייתך נכשלה אנא נסה שוב.",
              errorMessage: true
            });
          }
        });
    } else {
      console.log("validation error...");
    }
  }

  validateFullName(allowEmpty) {
    console.log("validateFullName...");
    this.state.fullNameValidated = false; //reset first , before check
    //required
    this.state.fullNameValidated =
      !isNullOrEmpty(this.state.fullName) || allowEmpty;
  }

  validateContent(allowEmpty) {
    console.log("validateContent...");
    this.state.contentValidated = false;

    //required
    this.state.contentValidated =
      !isNullOrEmpty(this.state.content) || allowEmpty;
  }

  validateEmail(allowEmpty) {
    console.log("validateEmail...");
    this.state.emailValidated = false;

    //required
    if (!isNullOrEmpty(this.state.email)) {
      this.state.emailValidated = StrIsEmailValidation(this.state.email);
    } else if (allowEmpty) {
      this.state.emailValidated = true;
    }
  }

  allowEmptyValidation = true; //onload
  validateAllFields(allowEmpty) {
    this.allowEmptyValidation = false;
    try {
      this.validateFullName(allowEmpty);
      this.validateContent(allowEmpty);
      this.validateEmail(allowEmpty);
    } catch (err) {
      console.log(err);
    }
    this.forceUpdate(); //force render , don't call this from render() / componentDidUpdate()
  }

  //get from cache on re-render
  // 2nd: resolver func to use more args after args[0]
  _resolver_ = (...args) => args.join(".");

  _validateFullName = _.memoize(this.validateFullName, this._resolver_);
  _validateEmail = _.memoize(this.validateEmail, this._resolver_);
  _validateContent = _.memoize(this.validateContent, this._resolver_);

  render() {
    //the state properties that recalc validation if changed
    const validationErrorClass = appClasses["validation-error"];

    this._validateFullName(this.allowEmptyValidation, this.state.fullName);
    const VfullName = this.state.fullNameValidated ? "" : validationErrorClass;
    //
    this._validateContent(this.allowEmptyValidation, this.state.content);
    const Vcontent = this.state.contentValidated ? "" : validationErrorClass;
    //
    this._validateEmail(this.allowEmptyValidation, this.state.email);
    const Vemail = this.state.emailValidated ? "" : validationErrorClass;

    const vrecaptcha = this.state.captchaClass;

    return (
      <Container className="mb-5">
        <HeaderImage viewName={this.state.viewName} />
        <Row className="mt-5">
          <Col className={classes.contactUsHeader}>
            הערות, הארות? נשמח לשמוע!
          </Col>
        </Row>
        <Row>
          <Col className={classes.contactUsSubHeader}>
            כל הערה שתתקבל תועבר לדיון בוועדת המפרט הרלוונטית
          </Col>
        </Row>
        <Form className={classes.contactUsForm}>
          <FormGroup row>
            <Col sm={5}>
              <Input
                aria-label="שם מלא"
                type="input"
                name="fullName"
                id="fullName"
                placeholder="שם מלא"
                className={VfullName}
                value={this.state.fullName}
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col sm={5}>
              <Input
                aria-label="כתובת דואל"
                type="input"
                name="email"
                id="email"
                placeholder="כתובת דואל"
                className={Vemail}
                value={this.state.email}
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col sm={5}>
              <Input
                aria-label="חברה (רשות)"
                type="input"
                name="companyName"
                id="companyName"
                placeholder="חברה (רשות)"
                value={this.state.companyName}
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col sm={5} xs={12}>
              <Input
                aria-label="כתוב לנו"
                type="textarea"
                name="content"
                id="content"
                placeholder="כתוב לנו"
                className={Vcontent}
                value={this.state.content}
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup check row>
            <Col sm={5} xs={12}>
              <Label check>
                <Input
                  aria-label="ברצוני לקבל עידכונים"
                  type="checkbox"
                  name="subscrib"
                  id="subscrib"
                  checked={this.state.subscrib}
                  onChange={this.cheackBoxHandleChange}
                />
                <span className={classes.subscribSpan}>
                  {" "}
                  ברצוני לקבל עידכונים
                </span>
              </Label>
            </Col>
          </FormGroup>
          <Row>
            <Col sm={4} xs={12} className={vrecaptcha}>
              <ReCAPTCHA
                ref={this.recaptchaRef}
                sitekey="6LdqpMYUAAAAAOnLPlnZrhXPfYNBxNyT8UonLDLN"
                onChange={this.captchaChange}
                hl="iw"
              />
            </Col>
          </Row>
          <Row>
            <Col sm="5" className={classes.sendButtonCol}>
              <Button
                className={classes.sendButton}
                onClick={() => this.sendEmail()}
              >
                שלח
              </Button>
            </Col>
          </Row>
          <Row>
            <Col
              className={
                this.state.errorMessage
                  ? classes.errorMessage
                  : classes.contactUsSubHeader
              }
            >
              {this.state.userMessage}
            </Col>
          </Row>
        </Form>
      </Container>
    );
  }
}

export default ContactUs;
